import {
    Gender,
    IBooking,
    IBookingChangelogEntry,
    ILegalEntity,
    InvoiceType,
    VipType
} from "../../types"

export enum BookingManagementPageTabs {
    BOOKING_ENTITY,
    DRIVER_DETAILS,
    CHANGE_LOG,
    ATTACHMENTS,
    MESSAGES,
    NOTES,
    SUBSTITUTIONS
}

export const MAX_CHAR_BODY_NOTE = 250;

export interface LocationState {
    bookingEntity: IBooking
}

export interface IFormValues {
    bookingId: {
        pendingReason: string,
        salesChannelCountry: string,
        salesChannel: string,
        createdBy: string,
        creationDateTime: string,
        cancellationDateTime: string,
        expirationDateTime: string,
        oldBookingCode: string,
        updatedBy: string,
        updateDateTime: string,
        cancelledBy: string,
        bookingDateTime: string,
        creditType: string | null,
    }
    mainDetails: {
        pickupLocation: string,
        pickupDate: string,
        pickupTime: string,
        dropoffLocation: string,
        dropoffDate: string,
        dropoffTime: string,
        totalRentalDays: number,
        bookedVehicleType: string,
        bookedCarGroup: string,
        carGroupModels: string,
        keyless: string,
        rce: string,
        ancillaries: {
            label: string, 
            sellType: string
        }[],
        deliveryStreetName?: string,
        deliveryStreetNumber?: string,
        deliveryPostalCode?: string,
        deliveryCity?: string,
        deliveryState: string,
        collectionStreetName?: string,
        collectionStreetNumber?: string,
        collectionPostalCode?: string,
        collectionCity?: string,
        collectionState: string,
        mileageIncluded: string,
        substitution: string
    },
    otherDetails: {
        segment: string,
        category: string,
        product: string,
        rate: string,
        rateId: string,
        leisureCode: string,
        codeDescription: string,
        customerCode: string,
        cig: string,
        cup: string,
        orderCode: string,
        specialConditionsAccepted: boolean,
        customerAtDesk: boolean,
        assignedPlateNumber: string,
        flightNumber: string,
        rentwayNumber: string,
        dossierNumber: string,
        replacementPlateNumber: string,
        affiliationCode: string,
        jimpiCustomerCode: string,
        vip: VipType,
        fcaBankCardNumber: string,
        rentalAgreement: string,
        parentRa: string,
        greenDiscount: string,
        fastLine: string,
        discountOverprice: string,
        keyless: boolean,
        rce: boolean,
        errorCode: string
    },
    mainDriverDetails: {
        id: string,
        firstName: string,
        lastName: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        mobilePrefix: string,
        webCheckIn: string,
        gender: Gender | ''
    },
    bookingOwnerDetails: {
        id: string,
        firstName: string,
        lastName: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        mobilePrefix: string,
        companyName: string,
        country: string,
        city: string,
        streetName: string,
        streetNumber: string,
        postalCode: string
        certifiedEmailAddress: string,
        telephone: string,
        vatNumber: string,
        vatNumberCountry: string,
        sdiCode: string,
        legalEntity: ILegalEntity | null,
        publicAuthority: string,
        paIdNumber: string,
        siren: string,
        siret: string,
        hasInvoiceOwnerChanged: boolean
    },
    billingOwnerDetails: {
        id: string,
        type: InvoiceType | '',
        firstName: string,
        lastName: string,
        birthDate: string,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        mobilePrefix: string,
        billingCountry: string,
        billingProvince: string,
        billingCity: string,
        billingStreetName: string,
        billingStreetNumber: string,
        billingPostalCode: string,
        certifiedEmailAddress: string,
        vatNumber: string,
        vatNumberCountry: string,
        invoiceCode: string,
        companyName: string,
        legalEntity: ILegalEntity | null,
        publicAuthority: string,
        paIdNumber: string,
        siren: string,
        siret: string,
        sapId: string | null,
        hasInvoiceOwnerChanged: boolean,
    },
    additionalDriversDetails: {
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        webCheckIn: string
    }[],
    substitutionDetail : {
        reason: string,
        eventDate: any,
        eventPlaceCountry: string,
        eventPlaceCity: string,
        eventPlaceProvince: string,
        eventPlacePostalCode: string,
        eventPlaceStreetName: string,
        eventPlaceStreetNumber: string,
        eventDescription: string,
        vehicleAvailability: boolean,
        policeInvolved: boolean,
        notePoliceInvolved: string,
        substancesInfluence: boolean,
        dropoffDate: string,
        dropoffTime: string,
        dropoffLocation: string,
    }
    subscriptionDetail : {
        dropoffDate: string,
        dropoffTime: string,
        dropoffLocation: string,
        dropoffDescLocation: string,
    }
}

export interface Message {
    id: string,
    user: string,
    timestamp: string,
    recipients: {
        id: string,
        label: string
    }[],
    subject: string,
    body: string
}

export type BookingChangelogTableRow = IBookingChangelogEntry;

export const CHECKIN = 'check-in';
